import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { getStakeColorAndClass } from "../../../utils/NumberDetails";

interface IInfoBox {
  title: string;
  content: string[];
  shouldShow: boolean;
}

const InfoBox: React.FC<IInfoBox> = ({ title, content, shouldShow }) => {
  const { t } = useTranslation();
  const scrollRef = useRef<HTMLDivElement>(null);

  const elements = content.map((el) => {
    let element;
    if (el === "R" || el === "B") {
      element = (
        <div className="diamond_shape" key={el}>
          <div className={`diamond ${el === "R" ? "red" : ""}`} />
          <div className="sign">
            {el === "R"
              ? t("panel.bettingPanel.red")
              : t("panel.bettingPanel.black")}
          </div>
        </div>
      );
    } else if (el === "EVEN" || el === "ODD") {
      element = (
        <div
          className="ball green"
          key={`specialBettingsParity_${el === "EVEN" ? "even" : "odd"}`}
        >
          {el === "EVEN"
            ? t("panel.bettingPanel.even")
            : t("panel.bettingPanel.odd")}
        </div>
      );
    } else {
      element = (
        <div
          className={`ball ${getStakeColorAndClass(el)}`}
          key={`numberBetting_${el}`}
        >
          {el}
        </div>
      );
    }
    return element;
  });

  const scrollToLeft = (): void => {
    scrollRef.current?.scrollBy(-100, 0);
  };

  const scrollToRight = (): void => {
    scrollRef.current?.scrollBy(100, 0);
  };

  return (
    <div className="info_box">
      <div className="title">{t(title)}</div>
      <div className="scroll_box">
        <div className="slides">
          <button
            type="button"
            className="prev prev_next"
            id="previous"
            onClick={scrollToLeft}
          >
            <span className="last_arrow arrow">&#10094;</span>
            <span className="first_arrow arrow">&#10094;</span>
          </button>
        </div>
        <div className="box">
          <div className="scroll" id="scroll" ref={scrollRef}>
            {shouldShow && elements}
          </div>
        </div>
        <div className="slides">
          <button
            type="button"
            className="next prev_next"
            id="next"
            onClick={scrollToRight}
          >
            <span className="first_arrow arrow">&#10095;</span>
            <span className="last_arrow arrow">&#10095;</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default InfoBox;
